export default __webpack_public_path__ + "images/swish-logos/swish.png";